import type { VendorMe } from "@motolynk/api-client";
import { createPanelApp, type NavGroupConfig } from "@motolynk/app-core";

import { modules } from "./modules";

// Sidebar sections most used first, set-up and settings last (Ruff_Plan/vendor.html). Empty sections stay hidden.
export const navGroups: NavGroupConfig[] = [
  { id: "main" },
  { id: "sales", label: "nav.groups.sales" },
  { id: "catalog", label: "nav.groups.catalog" },
  { id: "support", label: "nav.groups.support" },
  { id: "store", label: "nav.groups.store" },
];

export const App = createPanelApp({
  panel: "vendor",
  product: "VENDOR",
  modules,
  navGroups,
  authCopy: {
    headline: "common:authCopy.vendor.headline",
    subheadline: "common:authCopy.vendor.subheadline",
    points: [
      "common:authCopy.vendor.point1",
      "common:authCopy.vendor.point2",
      "common:authCopy.vendor.point3",
    ],
  },
  // Until the vendor is approved, only onboarding and the own account pages are reachable.
  guard: (me, pathname) => {
    const { onboarding_status: status } = me as VendorMe;
    if (status === "approved" || pathname === "/onboarding" || pathname.startsWith("/account"))
      return null;
    return "/onboarding";
  },
});
